export default "__VITE_ASSET__BjXI5YG4__"